import { BarChartSpec, barChartSpecSchema } from '../../../core';
import { createVisualization } from '../../../plugin-system';
import { BarChartIcon } from './BarChartIcon';
import { BarChartOptionsEditorAdvancedSettings } from './BarChartOptionsEditorAdvancedSettings';
import { BarChartOptionsEditorSettings } from './BarChartOptionsEditorSettings';
import { BarChartPanel } from './BarChartPanel';
import { createInitialBarChartSpec } from './bar-chart-model';

export const BarChart = createVisualization(BarChartPanel, {
  dashboardConfig: {
    kind: 'BarChart',
    mapSpecToProps: (spec: BarChartSpec) => spec,
    mapPropsToSpec: (props) => {
      const spec = { ...props };
      // These features aren't supported in dashboarding and should be omitted from the spec.
      delete spec.modeProcessing;
      delete spec.onModeChange;
      delete spec.showModeToggle;
      delete spec.comparisonPeriodLabel;
      delete spec.onBarClick;
      return spec;
    },
    panelOptionsEditorComponents: [
      {
        label: 'Settings',
        content: BarChartOptionsEditorSettings,
      },
      { label: 'Advanced', content: BarChartOptionsEditorAdvancedSettings },
    ],
    createInitialOptions: createInitialBarChartSpec,
    enableCompareMode: true,
    schema: barChartSpecSchema,
    supportedDataType: 'SingleValue',
    icon: BarChartIcon,
  },
});

export type BarChartVizProps = React.ComponentProps<typeof BarChart.Viz>;
export type BarChartVizBaseProps = React.ComponentProps<typeof BarChart.VizBase>;
